export const getMatchesCountText = (count) => {
    return count === 1 ? `1 match` : `${count} matches`;
};